import TriangleBackground from './TriangleBackground';

export default TriangleBackground;
